import { createContext } from 'react';
/**
 * React context instance for managing real-time state and controls
 * @public
 */
export const RealTimeContext = createContext({});